<template>
    <div class="sidebar">
        <ui-overlay-load v-if="loader.form" />

        <form ref="sidebar" class="sidebar-body scroll-color">
            <section class="content-block">
                <ui-input v-model="form.data.name" label="Nome da Fila:" size="md" :required="true" />

                <ui-select-v2
                    v-model="form.data.product_id"
                    :data="productOptions"
                    :search="true"
                    :multiple="false"
                    :loading="loader.productLoading"
                    label="Empreendimento:"
                    item-label="name"
                    return-value="id"
                    options-always-down
                />

                <ui-select-v2
                    v-model="form.data.type"
                    :data="queueTypeOptions"
                    :required="true"
                    label="Tipo de Fila:"
                    item-label="label" 
                    return-value="value"
                    :loading="loader.queueTypeLoading"
                    options-always-down
                />

                <ui-select-v2
                    v-show="form.data.type === 'form'"
                    v-model="form.data.form_data.field"
                    :data="formFieldsOptions"
                    :search="true"
                    :multiple="true"
                    :loading="form.formFieldsLoading"
                    group-by="type"
                    disable-select="disable"
                    label="Campos do Formulário:"
                    item-label="label"
                    options-always-down
                />

                <ui-select-v2
                    v-show="form.data.type === 'integration'" 
                    v-model="form.data.data.integration"
                    :data="integrationOptions"
                    :loading="form.integrationOptionsLoading"
                    label="Tipo de Integração:"
                    item-label="label"
                    return-value="value"
                    options-always-down
                />

                <div v-show="form.data.type === 'call_tracking'" >
                    <div class="buy-numbers">
                        <ui-input
                            v-model="models.calltracking" 
                            :mask="['(##) ####-####', '(##) #####-####']" 
                            label="Número de Destino:"/>

                        <ui-button
                            :disabled="!showCallTrackButton"
                            design="md block success"
                            @click="showCallTrackinModal">
                            Comprar Número
                        </ui-button>

                        <span v-if="models.numbersCanBuy === 0" >
                            <strong>Quantidade de números excedida.</strong>
                        </span>
                    </div>

                    <div v-show="form.data.calltracking.numbers.length" class="call-tracking-content" >
                        <div class="numbers-list">
                            <div v-for="(number, index) in form.data.calltracking.numbers" :key="index" class="numbers-list-item">
                                <div class="number">
                                    {{ number.number | phoneMask }}
                                    <ui-button design="xs danger" @click="handleRemoveNumber(index)">Remover</ui-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ui-switch
                    id="marketing-queues-add-form-queue-status"
                    v-model="form.data.status"
                    :checked="form.data.status"
                    label="Fila Ativada"
                    name="remember"
                    design="xs primary"
                />
                <ui-switch
                    id="marketing-queues-add-form-queue-status"
                    v-model="form.data.data.sdr"
                    :checked="form.data.data.sdr"
                    label="Usuários da fila serão SDR"
                    name="remember"
                    design="xs primary"
                />
            </section>

            <section v-show="form.data.type !== 'integration'" class="content-block">
                <section class="label">
                    <div class="title">Funil de Vendas</div>
                    <div>Informe a etapa e status ao qual o lead será cadastrado.</div>
                </section>

                <ui-select-v2
                    v-model="form.data.funnel_stage_id"
                    :data="funnelStageOptions"
                    :loading="loader.funnelStageLoading"
                    label="Selecione etapa:"
                    item-label="name"
                    return-value="id"
                    options-always-down
                    @input="stageSelectHandler"
                />

                <ui-select-v2
                    v-model="form.data.funnel_stage_status_id"
                    :data="funnelStageStatusOptions"
                    :required="statusRequired"
                    :error="hasError && statusRequired"
                    :loading="form.funnelStageStatusLoading"
                    label="Selecione status:"
                    item-label="name"
                    return-value="id"
                    options-always-down
                />
            </section>

            <section class="content-block">
                <section class="label">
                    <div class="title">Canais, Origens e Tags</div>
                </section>

                <ui-select-v2
                    v-model="form.data.origin"
                    :data="customerOriginOptions"
                    :loading="loader.customerOriginLoading"
                    :add-selecteds="form.fields.origin.canAddAction"
                    search
                    required
                    label="Origem:"
                    return-value="id"
                    item-label="label"
                    options-always-down
                />

                <ui-select-v2
                    v-model="form.data.channel"
                    :data="customerChannelOptions"
                    :loading="loader.customerChannelLoading"
                    :add-selecteds="form.fields.origin.canAddAction"
                    search
                    required
                    label="Canal:"
                    return-value="id"
                    item-label="label"
                    options-always-down
                />

                <ui-select-v2
                    v-model="form.data.dealsTags"
                    :data="customerDealsTagsOptions"
                    :loading="loader.customerDealsTagsLoading"
                    open-event="queue-deals-tags"
                    search
                    multiple
                    label="Tags:"
                    return-value="value"
                    item-label="label"
                    options-always-down
                />
            </section>

            <section v-if="checkAppsAllowed('old_origin_field')" class="tags-content-block" :style="tagsContentBlockStyle">
                <div class="title" @click="toggleTags">
                    <em class="far" :class="tagsOpenned ? 'fa-angle-up fa-lg' : 'fa-angle-down fa-lg'"/>
                </div>

                <div v-show="tagsOpenned">
                    <ui-select-v2
                        v-model="form.data.tags"
                        :data="customerTagsOptions"
                        :loading="loader.customerTagsLoading"
                        open-event="queue-tags"
                        search
                        multiple
                        label="Origem Antiga:"
                        return-value="value"
                        item-label="label"
                        options-always-down
                    />

                    <div class="warning">
                        <span>
                            <strong>Obs:</strong> Este campo é referente à antiga origem e só será necessário cadastrar se você desejar esta informação em seus relatórios.
                        </span>
                    </div>
                </div>
            </section>
        </form>

        <div class="sidebar-footer">
            <ui-button design="lg block success" :disabled="disabledButton" @click="submit(btnSubmitText)">{{btnSubmitText}}</ui-button>
        </div>
    </div>
</template>

<script>
	import { uiInput, uiSwitch, uiSelectV2 } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { uiOverlayLoad } from '@/components/ui'

	import { phoneMask } from "@/filters"
	import { storage } from '@/services/storage'

	import {
		channels,
		configuration,
		funnel,
		lead,
		origins,
		product,
		tag,
		integration,
	} from '@/services/axios'

	import { mapGetters } from 'vuex'

	const defaultLoader = () => {
		return {
			form: false,
			queueTypeLoading: false,
			customerOriginLoading: false,
			productLoading: false,
			funnelStageLoading: false,
			funnelStageStatusLoading: false,
			formFieldsLoading: false,
			integrationOptionsLoading: false,
			customerChannelLoading: false,
			customerDealsTagsLoading: false,
			customerTagsLoading: false,
		}
	}

	const FormDataOptions = [
		{
			value: 'name',
			label: 'Nome',
			type: 'Campos Obrigatórios',
			disable: true,
			id: 1
		},
		{
			value: 'email',
			label: 'E-mail',
			type: 'Campos Obrigatórios',
			disable: true,
			id: 2
		},
		{
			value: 'phone',
			label: 'Telefone',
			type: 'Campos Obrigatórios',
			disable: false,
			id: 3
		},
		{
			value: 'mobile',
			label: 'Celular',
			type: 'Campos Obrigatórios',
			disable: false,
			id: 4
		},
		{
			value: 'cpf',
			label: 'CPF',
			type: 'Campos Obrigatórios',
			disable: false,
			id: 5
		},
		{
			value: 'message',
			label: 'Mensagem',
			type: 'Campos Obrigatórios',
			disable: false,
			id: 6
		},
		{
			value: 'products',
			label: 'Empreendimento',
			type: 'Campos Opcionais',
			disable: false,
			id: 7
		},
		{
			value: 'profession',
			label: 'Profissão',
			type: 'Campos Opcionais',
			disable: false,
			id: 8
		},
		{
			value: 'business',
			label: 'Empresa',
			type: 'Campos Opcionais',
			disable: false,
			id: 9
		},
		{
			value: 'income',
			label: 'Renda Familiar',
			type: 'Campos Opcionais',
			disable: false,
			id: 10
		},
		{
			value: 'state_civil',
			label: 'Estado Civil',
			type: 'Campos Opcionais',
			disable: false,
			id: 11
		},
		{
			value: 'children',
			label: 'Quantidade de Filhos',
			type: 'Campos Opcionais',
			disable: false,
			id: 12
		},
		{
			value: 'phone_resindetial',
			label: 'Telefone Residencial',
			type: 'Campos Opcionais',
			disable: false,
			id: 13
		},
		{
			value: 'address',
			label: 'Endereço',
			type: 'Campos Opcionais',
			disable: false,
			id: 14
		},
		{
			value: 'complement',
			label: 'Complemento',
			type: 'Campos Opcionais',
			disable: false,
			id: 15
		},
		{
			value: 'state',
			label: 'Estado',
			type: 'Campos Opcionais',
			disable: false,
			id: 16
		},
		{
			value: 'city',
			label: 'Cidade',
			type: 'Campos Opcionais',
			disable: false,
			id: 17
		}
	]

	export default {
		name: 'ui-sidebar-form-add-queue',
		components: {
			uiInput,
			uiSwitch,
			uiButton,
			uiOverlayLoad,
			uiSelectV2
		},

        filters: { 
            phoneMask
        },

		props: {
			/**
			 * Recebe os métodos do componente TEMPLATE
			 * métodos: show, hide e toggle
			 */
			methods: {
				type: [Object, Function],
				required: false,
				default() {
					return {}
				},
			},
		},

		data() {
			return {
				models: {
					calltracking: '',
					calltrackingNumbers: [],
					numbersCanBuy: 0
				},
				hasError: false,
				queueStatusToggle: true,
				loading: false,
				showCallTrackButton: false,
				statusRequired: false,
				loader: { ...defaultLoader() },
				tagsOpenned: false,
				form: {
					fields: {
						type: {
							required: true
						},
						origin: {
							required: true,
							canAddAction: false,
						},
						product_id: {
							required: true
						},
						funnel_stage_id: {
							required: true
						},
						funnel_stage_status_id: {
							required: true
						},
						form_data: {
							required: true,
							disabled: false
						}
					},
					data: {
						name: '',
						type: 'form',
						origin: '',
						channel: '',
						dealsTags: [],
						tags: [],
						product_id: '',
						funnel_stage_id: '',
						funnel_stage_status_id: '',
						calltracking: {
							numbers: []
						},
						form_data: {
							field: []
						},
						data: {
							integration: null,
							sdr: true
						},
						status: true
					}
				},
				queueTypeOptions: [
					{ id: 1, label: 'Formulário', value: 'form' },
					{ id: 2, label: 'Integração', value: 'integration' },
					{ id: 3, label: 'Redistribuição', value: 'redistribution' }
				],
				integrationOptions: [
					{ id: 2, label: 'Outros', value: 'outros' },
					{ id: 3, label: 'Zapier', value: 'zapier' }
				],
				formFieldsOptions: [...FormDataOptions],
				customerOriginOptions: [],
				productOptions: [],
				funnelStageOptions: [],
				funnelStageStatusOptions: [],
				customerChannelOptions: [],
				customerDealsTagsOptionsAlreadyRequested: false,
				customerDealsTagsOptions: [],
				customerTagsOptionsAlreadyRequested: false,
				customerTagsOptions: [],
				allowedApps: null,
			}
		},
		
		computed: {
			...mapGetters('lead', {
				leadQueue: 'getQueue'
			}),

			tagsContentBlockStyle() {
				return this.tagsOpenned ? "padding: 25px; border-bottom: 1px solid #E1E1EF;" : ""
			},

			disabledButton(){
				let hasError = false

				if (!this.form.data.name) hasError = true
				if (Array.isArray(this.form.data.type) || !this.form.data.type) hasError = true
				if (Array.isArray(this.form.data.funnel_stage_status_id || !this.form.data.funnel_stage_status_id) && this.statusRequired) hasError = true
				if (this.form.data.type === 'call_tracking' && this.form.data.calltracking.numbers.length === 0) hasError = true
				if (Array.isArray(this.form.data.origin) || !this.form.data.origin) hasError = true
				if (Array.isArray(this.form.data.channel) || !this.form.data.channel) hasError = true

				return hasError
			},
			
			btnSubmitText() {
				return this.leadQueue ? 'Salvar Alterações' : 'Criar Fila'
			},
		},


		watch: {
			'models.calltracking': function(val){
				this.showCallTrackButton = val.length >= 14 && this.models.numbersCanBuy > 0
			},

			'form.data.type': function(val){
				if (!this.leadQueue && val === 'form') this.formFieldsOptions = [...FormDataOptions]
			}
		},

		created() {
			this.allowedApps = storage.get('allowed_apps')
		},

		mounted() {
			this.$nextTick(async () => {
				this.$root.$on('modal-calltrack-select-number-resolve', (data) => {
					const callTracking = [...data]
					this.$set(this.form.data.calltracking, 'numbers', callTracking)
				})
			})

			this.$root.$on('sidebar-form-add-queue-load-form', async () => {
				await this.loadForm()
			})

			this.$root.$on('select-v2-open-event-queue-deals-tags', async () => {
				if (!this.customerDealsTagsOptionsAlreadyRequested) {
					/** Carrega as deals tags */
					this.setLoader('customerDealsTagsLoading')
					const response = await tag.getTagOptions('deal_main')
					this.customerDealsTagsOptions = [...response.data.map(e => { return { label: e.label, value: e.label } })]
					this.setLoader('customerDealsTagsLoading')

					this.customerDealsTagsOptionsAlreadyRequested = true
				}
			})

			this.$root.$on('select-v2-open-event-queue-tags', async () => {
				/** Verifica se "old_origin_field" está ativo na Database */
				if (this.checkAppsAllowed('old_origin_field') && !this.customerTagsOptionsAlreadyRequested) {
					/** Carrega as tags dos clientes */
					this.setLoader('customerTagsLoading')
					const response = await tag.getTagOptions('leads_main')
					this.customerTagsOptions = [...response.data.map(e => { return { label: e.label, value: e.label } })]
					this.setLoader('customerTagsLoading')

					this.customerTagsOptionsAlreadyRequested = true
				}
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-calltrack-select-number-resolve')
			this.$root.$off('sidebar-form-add-queue-load-form')
			this.$root.$off('select-v2-open-event-queue-deals-tags')
			this.$root.$off('select-v2-open-event-queue-tags')
		},
		
		methods: {
			/**
			 * Verifica se um app está ativo na Database
			 */
			checkAppsAllowed(name) {
				return this.allowedApps.includes(name)
			},
			/**
			 * Abre ou fecha o bloco de "Origem Antiga"
			 */
			toggleTags() {
				this.tagsOpenned = !this.tagsOpenned

				this.$nextTick(() => {
					// Has been openned and div updated
					if (this.tagsOpenned) {
						const container = this.$refs.sidebar;
						if (container) container.scrollTop = container.scrollHeight;
					}
				})
			},
			/**
			 * Carrega as configurações do sistema
			 */
			loadConfigurations() {
				return new Promise((resolve, reject) => {
					configuration.getConfigurations()
						.then(response => {
							let data = response.data
							for (var prop in data) {
								if (Object.prototype.hasOwnProperty.call(data, prop)) {
									switch (data[prop].name) {
										case 'menuAllowed':
											if (data[prop].value_long) {
												if (data[prop].value_long.includes('chat')) {
													this.queueTypeOptions = [...this.queueTypeOptions, {label: 'Chat', value: 'chat', id: 4 }]
												}

												if (data[prop].value_long.includes('calltracking')) {
													this.queueTypeOptions = [...this.queueTypeOptions, { label: 'Call Tracking', value: 'call_tracking', id: 5 }]

													integration
														.getAll('voice/numbersCanBuy')
														.then(response => {
															this.$set(this.models, 'numbersCanBuy', response.data)
														})
														.catch(error => {
															if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
														})
												}
											}
											break

										case 'customerTags':
											var config = data[prop].value_long
											if (config && config.insert === 'active')
												this.$set(this.form.fields.origin, 'canAddAction', true)
											break

										case 'allowedApps':
												if (data[prop].value_long.includes('whatsapp'))
													this.queueTypeOptions = [...this.queueTypeOptions, {label: 'Whatsapp', value: 'whatsapp', id: 5 }]
											break
									}
								}
							}
							resolve()
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
							reject()
						})
				})
			},
			/**
			 * Carrega os dados necessários para montar o formulário
			 */
			async changeData(axiosLoad, functionLoad, setData, loader, paramer = null) {
				this.loaderMap(loader)
				if(paramer) {
					return await axiosLoad[functionLoad](paramer.paramer, paramer.object).then(async response => {
						this[setData] = 
						paramer.map ? [...response.data.map(e => { return { label: e.label, value: e.label } })] : [...response.data]

						// Garante que os IDs das opções de Origem e Canal sejam inteiros
						if (['customerOriginOptions', 'customerChannelOptions'].includes(setData)) {
							this[setData] = Object.values(this[setData]).map(option => {
								option.id = parseInt(option.id)
								
								return option
							})
						}

						await this.loaderMap(loader)
					}).catch(err => {
						this.loaderMap(loader)
						console.log(err);
					})
				}
				await axiosLoad[functionLoad]().then(async response => {
					this[setData] = [...response.data]
					await this.loaderMap(loader)
				}).catch(err => {
					this.loaderMap(loader)
					console.log(err);
				})
			},
			
			loaderMap(loader) {
				if(loader && loader.length && loader.length > 0) {
					loader.map(element => {
						this.setLoader(element)
					});
				}
			},
			async loadForm() {
				this.setLoader('form')
				this.loadConfigurations()
					.then(async () => {
						try {
							/** Carrega os empreendimentos cadastrados */
							await this.changeData(product, 'getProductWithoutAvailable', 'productOptions', ['productLoading'])

							/** Carrega as etapas disponíveis */
							await this.changeData(funnel, 'getStages', 'funnelStageOptions', ['funnelStageLoading', 'funnelStageStatusLoading'])
						
							/** Carrega as origens dos clientes */
							await this.changeData(origins, 'getOrigins', 'customerOriginOptions', ['customerOriginLoading'])

							/** Carrega os canais de contato */
							await this.changeData(channels, 'getAllV2', 'customerChannelOptions', ['customerChannelLoading'], 
								{ 
									paramer: '', 
									object: {},
									map: false
								}
							)

							if (this.leadQueue) {
								if (!this.customerDealsTagsOptionsAlreadyRequested) {
									/** Carrega as deals tags */
									await this.changeData(tag, 'getTagOptions', 'customerDealsTagsOptions', ['customerDealsTagsLoading'], 
										{
											paramer: 'deal_main', 
											object: null, 
											map: true
										}
									)
									this.customerDealsTagsOptionsAlreadyRequested = true
								}

								/** Verifica se "old_origin_field" está ativo na Database */
								if (this.checkAppsAllowed('old_origin_field') && !this.customerTagsOptionsAlreadyRequested) {
									/** Carrega as tags dos clientes */
									await this.changeData(
										tag, 
										'getTagOptions', 'customerTagsOptions', ['customerTagsLoading'], 
										{
											paramer: 'leads_main', 
											object: null, 
											map: true
										}
									)
									this.customerTagsOptionsAlreadyRequested = true
								}

								this.$set(this.form.data, 'id', this.leadQueue.id)
								this.$set(this.form.data, 'product_id', this.leadQueue.product_id ? this.leadQueue.product_id : [])
								this.$set(this.form.data, 'funnel_stage_id', this.leadQueue.funnel_stage_id ? this.leadQueue.funnel_stage_id : [])
								this.$set(this.form.data, 'funnel_stage_status_id', [])
								this.$set(this.form.data, 'calltracking', this.leadQueue.calltracking ? { numbers: [...this.leadQueue.calltracking] } : { numbers: [] })
								this.$set(this.form.data, 'type', this.leadQueue.type ? this.leadQueue.type : 'form')
								this.$set(this.form.data, 'name', this.leadQueue.name ? this.leadQueue.name : '')
								this.$set(this.form.data, 'data', this.leadQueue.data && this.form.data.type === 'integration' ? { integration: this.leadQueue.data.integration, sdr: this.leadQueue?.data?.sdr == 1 ? true : false } : { integration: null, sdr: this.leadQueue?.data?.sdr == 1 ? true : false })
								this.$set(this.form.data, 'status', this.leadQueue.status === 'active' ? true : false)
								this.$set(this.form.data, 'users', this.leadQueue.lusers ? this.leadQueue.lusers : [])
								this.$set(this.form.data, 'origin', this.leadQueue.origin.id)
								this.$set(this.form.data, 'channel', this.leadQueue.channel_id)

								const dealsTags = this.leadQueue.tags.filter((tagFiltered) => tagFiltered.v2 == 1)
								this.$set(this.form.data, 'dealsTags', dealsTags ? dealsTags.map(e => {
									return e.tag
								}) : [])

								/** Verifica se "old_origin_field" está ativo na Database */
								if (this.checkAppsAllowed('old_origin_field')) {
									const leadsTags = this.leadQueue.tags.filter((tagFiltered) => tagFiltered.v2 == 0)
									this.$set(this.form.data, 'tags', leadsTags ? leadsTags.map(e => {
										return e.tag
									}) : [])
								}

								this.$set(this.form.data, 'form_data', this.leadQueue.form_data && this.form.data.type === 'form' ? 
									{ field: this.formFieldsOptions.filter(e => {
										if (this.leadQueue.form_data.field && this.leadQueue.form_data.field.includes(e.value)) {
											return e
										}
										else if(!this.leadQueue.form_data.field && this.leadQueue.form_data.includes(e.value)) {
											return e
										}
									} ) } : { field: [] }
								)

								if (this.form.data.type === 'call_tracking' && this.form.data.calltracking && this.form.data.calltracking.numbers) {
									this.models.calltracking = this.form.data.calltracking.numbers[0].destiny_number
								}

								this.loadStageStatusOptions(this.leadQueue.funnel_stage_id)
									.finally(() => {
										this.form.data.funnel_stage_id = this.leadQueue.funnel_stage_id
										this.form.data.funnel_stage_status_id = this.leadQueue.funnel_stage_status_id
									})
							}

							this.$emit('completed')
							this.setLoader('form')
						} catch (err){
							console.log(err);
						}
					})
					.catch(() => {
						this.setLoader('form')
						this.$toastr.e('Falha ao carregar as configurações de formulário.')
						this.$router.go(-1)
					})
			},
			/**
			 * Executa o médoto de esconder o sidebar
			 * O método vem do template
			 */
			hide() {
				if (this.methods && this.methods.hide) this.methods.hide()
			},
			/**
			 * Executa o médoto de esconder o sidebar
			 * O método vem do template
			 */
			show() {
				if (this.methods && this.methods.show) this.methods.show()
			},
			/**
			 * Carrega o select de status de acordo com a etapa selecionada
			 */
			loadStageStatusOptions(stageId){
				return new Promise((resolve) => {
					this.$set(this.loader, 'funnelStageStatusLoading', true)

					this.funnelStageStatusOptions = []

					let stage = Object.values(this.funnelStageOptions).find(stage =>  stage.id === parseInt(stageId))

					if (stage){
						if(stage.status.length) {
							this.funnelStageStatusOptions = [...stage.status]
							this.statusRequired = true
						}else{
							this.statusRequired = false
							this.funnelStageStatusOptions = []
						}
					}

					this.$set(this.loader, 'funnelStageStatusLoading', false)

					resolve()
				})
			},
			/**
			 * Input handler executado quando uma etapa é selecionada
			 */
			stageSelectHandler(stageId) {
				if(!Array.isArray(stageId)){
					this.form.data.funnel_stage_status_id = null
					this.loadStageStatusOptions(stageId)
				}
			},
			/**
			 * Salva os dados do formulário e criando ou atualizando uma fila
			 */
			save: async function () {
				let request = null

				try {
					// Verifica se a origem selecionada ainda não foi cadastrada
					if (this.form.data.origin &&
						!Array.isArray(this.form.data.origin) &&
						typeof this.form.data.origin === 'string') {
						await this.createOrigin()
					}

					// Verifica se o canal selecionado ainda não foi cadastrado
					if (this.form.data.channel &&
						!Array.isArray(this.form.data.channel) &&
						typeof this.form.data.channel === 'string') {
						await this.createChannel()
					}

					let formData = {
						id: this.form.data.id,
						product_id: Array.isArray(this.form.data.product_id) || !this.form.data.product_id ? null : this.form.data.product_id,
						funnel_stage_id: this.form.data.funnel_stage_id,
						funnel_stage_status_id: this.form.data.funnel_stage_status_id,
						type: this.form.data.type,
						name: this.form.data.name,
						status: this.form.data.status ? 'active' : 'inactive',
						lusers: this.form.data.lusers,
						origin_id: Array.isArray(this.form.data.origin) || !this.form.data.origin ? null : this.form.data.origin,
						channel_id: Array.isArray(this.form.data.channel) || !this.form.data.channel ? null : this.form.data.channel,
						deals_main: !this.form.data.dealsTags ? null : this.form.data.dealsTags,
						leads_main: !this.form.data.tags ? null : this.form.data.tags,
						form_data: {
							field: null
						}
					}

					if (this.form.data.type === 'integration') {
						formData.data = { integration: this.form.data.data.integration }
					}

					if (formData.data) {
						formData.data.sdr = this.form.data.data.sdr ? 1 : 0
					} else {
						formData.data = { sdr: this.form.data.data.sdr ? 1 : 0 }
					}

					if (this.form.data.type === 'form') {
						formData.form_data.field = this.form.data.form_data.field.map(e => {
							return e.value
						})
					}

					if (this.form.data.type === 'call_tracking') {
						const n = this.models.calltracking.replace(/([^\d])+/gim, '')
						formData.call_tracking = {
							numbers : this.form.data.calltracking.numbers.map(e => {
								return {
									name: e.name,
									provider_number: e.name,
									destiny_number: n.length === 11 ? '55' + n : n,
									provider: e.provider
								}
							})
						}
					}

					if (this.leadQueue && this.leadQueue.id) {
						request = lead.update('', this.leadQueue.id, formData)

					} else {
						request = lead.create('', formData)                        
					}

				} catch (error) {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log(error)
				}

				return request
			},
			/**
			 * Submita os dados do formulário e permite prosseguir para a atribuição de
			 * usuários a uma fila
			 */
			submit(text) {
				if(text == 'Criar Fila') {
					this.$gtm.trackEvent({
						event: "fac_button_click",
						category: 'vuejs-origens',
						action: "click",
						label: text,
					})
				}
				if (this.disabledButton) {
					this.hasError = true
					return
				}

				this.$set(this.loader, 'form', true)
				this.save().then(response => {
					this.$store.dispatch('lead/setQueue', response.data.data)

					if (!this.leadQueue) {
						this.$router.push({
							name: 'marketing.queues.add',
							params: {
								id: response.data.data.id,
								title: response.data.data.lead_name,
								type: response.data.data.lead_type
							}
						})
					}
					this.$emit('submit')
				})
				.catch(error => {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
				})
				.finally(() => {
					this.$set(this.loader, 'form', false)
				})
			},

			showCallTrackinModal(){
				this.$root.$emit('modal-open-marketing-queues-call-tracking', this.models.numbersCanBuy)
			},

			setLoader(name) {
				this.loader[name] = !this.loader[name]
			},
			/**
			 * Cadastra a origem selecionada no banco de dados, caso esta ainda não tenha
			 * sido registrada
			 */
			createOrigin() {
				const origin = {
					slug: this.form.data.origin,
					type: 'System'
				}

				return origins.createV2('', origin)
					.then(response => {
						if (response.data && response.data.length) {
							const index = this.customerOriginOptions.findIndex(item => item.label === origin.slug)
							this.customerOriginOptions.splice(index, 1, { ...response.data[0] })
							this.form.data.origin = response.data[0].id
						}
					})
			},
			/**
			 * Cadastra o canal selecionado no banco de dados, caso este ainda não tenha
			 * sido registrado
			 */
			createChannel() {
				const channel = {
					slug: this.form.data.channel,
					type: 'System',
				}

				return channels.createV2('', channel)
					.then(response => {
						if (response.data && response.data.length) {
							const index = this.customerChannelOptions.findIndex(item => item.label === origin.slug)
							this.customerChannelOptions.splice(index, 1, { ...response.data[0] })
							this.form.data.channel = response.data[0].id
						}
					})
			},
			/**
			 * Remove o número selecionado pelo call-tracking
			 */
			handleRemoveNumber(id) {
				this.form.data.calltracking.numbers.splice(id,1)
				this.$root.$emit('remove-number-event', id)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
